import Entity from './entity'
export default class moisture_data extends Entity<number>{
}